module.exports = __webpack_public_path__ + "static/media/konqiyuan.6c219e42.gif";